export default __webpack_public_path__ + "static/media/img9.f095487f.PNG";